import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
export default class DeluxePlayerPositionComponent extends Component {
  @tracked index = 0;
  formats = ['time', 'length'];

  get format() {
    return this.formats[this.index % this.formats.length];
  }

  @action
  toggleFormat() {
    this.index = this.index + 1;
  }
}
